import type { SocialLink } from '@/types';
import { profile } from '@/data/profile';

export const socialLinks: SocialLink[] = [
  {
    id: 'github',
    platform: 'github',
    label: 'GitHub',
    href: profile.githubUrl,
    external: true,
  },
  {
    id: 'email',
    platform: 'email',
    label: 'Email',
    href: `mailto:${profile.email}`,
  },
  {
    id: 'website',
    platform: 'website',
    label: 'Website',
    href: profile.websiteUrl,
    external: true,
  },
  // TODO: Add LinkedIn (or other profiles) only when you have a confirmed public URL.
];
